import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { SafeHtmlPipe } from '@shared/pipes/safe-html.pipe';

@Component({
	selector: 'kwo-highlighted-video-slider',
	templateUrl: './highlighted-video-slider.component.html',
	styleUrls: ['./highlighted-video-slider.component.scss'],
	standalone: true,
	imports: [CommonModule, RouterModule, SlickCarouselModule, SafeHtmlPipe],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class HighlightedVideoSliderComponent implements OnInit {

	@Input() slider: any;

	slideConfig = {
		infinite: false,
		slidesToShow: 5,
		slidesToScroll: 5,
		centerMode: false,
		arrows: true,
		dots: false,
		swipeToSlide: true,
		prevArrow: '<div class="ngx_splide__arrow ngx_splide__arrow--prev"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" width="40" height="40" focusable="false"><path d="m15.5 0.932-4.3 4.38 14.5 14.6-14.5 14.5 4.3 4.4 14.6-14.6 4.4-4.3-4.4-4.4-14.6-14.6z"></path></svg></div>',
		nextArrow: '<div class="ngx_splide__arrow ngx_splide__arrow--next"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" width="40" height="40" focusable="false"><path d="m15.5 0.932-4.3 4.38 14.5 14.6-14.5 14.5 4.3 4.4 14.6-14.6 4.4-4.3-4.4-4.4-14.6-14.6z"></path></svg></div>',
		responsive: [
			{
				breakpoint: 1920,
				settings: {
					arrows: true,
					centerMode: false,
					slidesToShow: 4,
					slidesToScroll: 4,
					speed: 80
				}
			},
			{
				breakpoint: 992,
				settings: {
					arrows: false,
					centerMode: false,
					slidesToShow: 2.8,
					speed: 80
				}
			},
			{
				breakpoint: 480,
				settings: {
					arrows: false,
					centerMode: false,
					slidesToShow: 1.8,
					speed: 80
				}
			}
		]
	};

	constructor(private router: Router) { }

	ngOnInit(): void {
	}

	goToVideo(slug: string) {

		this.router.navigate(['/video/', slug]);
	}
}
